import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { getUserColorFromId } from '@fabric-app/utils/color';
import Avatar from '../Avatar/Avatar.js';
import { getUserAvatarUrl } from '../../utils/getUserAvatarUrl.js';

const AvatarUser = /* @__PURE__ */ forwardRef(({ user, disableTooltip, ...props }, ref) => /* @__PURE__ */ jsx(Avatar, {
  color: user?.id ? getUserColorFromId(user.id) : void 0,
  tooltip: disableTooltip ? void 0 : user?.name,
  ...props,
  ref,
  children: user ? /* @__PURE__ */ jsx(Avatar.Image, {
    src: getUserAvatarUrl(user) || void 0,
    alt: user.name ?? "Avatar",
    children: /* @__PURE__ */ jsx(Avatar.Text, {
      children: user.name?.charAt(0)
    })
  }) : /* @__PURE__ */ jsx(Avatar.Spinner, {})
}));
AvatarUser.displayName = "AvatarUser";

export { AvatarUser as default };
//# sourceMappingURL=AvatarUser.js.map
